import { render } from "./RegisterCta.vue?vue&type=template&id=4a035610&scoped=true&ts=true"
import script from "./RegisterCta.vue?vue&type=script&lang=ts"
export * from "./RegisterCta.vue?vue&type=script&lang=ts"

import "./RegisterCta.vue?vue&type=style&index=0&id=4a035610&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a035610"]])

export default __exports__